const photos = [
  {
    key: 1,
    alt: "Data Centre",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2788598/files/IMG_0053.jpg?subformat=icon-1440",
  },

  {
    key: 2,
    alt: "Data Centre",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2788598/files/IMG_0045.jpg?subformat=icon-1440",
  },

  {
    key: 3,
    alt: "Data Centre",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2788598/files/IMG_9974.jpg?subformat=icon-1440",
  },

  {
    key: 4,
    alt: "Data Centre",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2788598/files/IMG_0121.jpg?subformat=icon-1440",
  },

  {
    key: 5,
    alt: "LHCb - Control Room",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2791987/files/IMG_0574.jpg?subformat=icon-1440",
  },

  {
    key: 6,
    alt: "LHCb - DELPHI Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2791987/files/IMG_0595.jpg?subformat=icon-1440",
  },

  {
    key: 7,
    alt: "LHCb Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2791987/files/IMG_0606.jpg?subformat=icon-1440",
  },

  {
    key: 8,
    alt: "ALICE Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790673/files/IMG_9092.jpg?subformat=icon-1440",
  },

  {
    key: 9,
    alt: "ALICE Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790673/files/IMG_9104.jpg?subformat=icon-1440",
  },

  {
    key: 10,
    alt: "Silicon detectors",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2789072/files/IMG_0197.jpg?subformat=icon-1440",
  },

  {
    key: 11,
    alt: "LHCb Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790811/files/IMG_0506-2.jpg?subformat=icon-1440",
  },

  {
    key: 12,
    alt: "LHCb Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790811/files/IMG_0507.jpg?subformat=icon-1440",
  },

  {
    key: 13,
    alt: "CLIC Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790804/files/IMG_0336.jpg?subformat=icon-1440",
  },

  {
    key: 14,
    alt: "CLIC Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790804/files/IMG_0409.jpg?subformat=icon-1440",
  },

  {
    key: 15,
    alt: "ALICE Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790673/files/IMG_9089.jpg?subformat=icon-1440",
  },

  {
    key: 16,
    alt: "LHCb Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2791987/files/IMG_0618.jpg?subformat=icon-1440",
  },

  {
    key: 17,
    alt: "Silicon detectors",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2789072/files/IMG_0148.jpg?subformat=icon-1440",
  },

  {
    key: 18,
    alt: "Silicon detectors",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2789072/files/IMG_0164.jpg?subformat=icon-1440",
  },

  {
    key: 19,
    alt: "Silicon detectors",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2789072/files/IMG_0187.jpg?subformat=icon-1440",
  },

  {
    key: 20,
    alt: "Silicon detectors",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2789072/files/IMG_0189.jpg?subformat=icon-1440",
  },

  {
    key: 21,
    alt: "CMS Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790811/files/IMG_0500.jpg?subformat=icon-1440",
  },

  {
    key: 22,
    alt: "Antimatter Factory",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790882/files/IMG_0523.jpg?subformat=icon-1440",
  },
  {
    key: 23,
    alt: "CMS Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2790811/files/IMG_0447.jpg?subformat=icon-1440",
  },

  {
    key: 24,
    alt: "LHCb Experiment",
    photographer: "Franciska-Leonora Torok",
    src: "https://cds.cern.ch/record/2791987/files/IMG_0617.jpg?subformat=icon-1440",
  },
];

export function getPhotos() {
  return photos;
}
